import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  doctors: [],
  doctorsCount: null,
  doctorDept: [],
  loading: false,
  isDoctorCreated: false,
  doctor: null,
};

const doctorsSlice = createSlice({
  name: "doctor",
  initialState,
  reducers: {
    setDoctors(state, action) {
      state.doctors = action.payload;
    },
    setDoctorsCount(state, action) {
      state.doctorsCount = action.payload;
    },
    setDcotorsDept(state, action) {
      state.doctorDept = action.payload;
    },
    setLoading(state) {
      state.loading = true;
    },
    clearLoading(state) {
      state.loading = false;
    },
    setIsDoctorCreated(state) {
      state.isDoctorCreated = true;
      state.loading = false;
    },
    clearIsDoctorCreated(state) {
      state.isDoctorCreated = false;
    },
    setDoctor(state, action) {
      state.doctor = action.payload;
    },
    setLike(state, action) {
      state.doctor.likes = action.payload.likes;
    },
    deleteDoctor(state, action) {
      state.doctors.likes = state.doctors.filter(
        (d) => d._id !== action.payload
      );
    },
    addCommentToDoctor(state, action) {
      state.doctor.comments.push(action.payload);
    },
    updateCommentToDoctor(state, action) {
      state.doctor.comments = state.doctor.comments.map((comment) =>
        comment?._id === action.payload._id ? action.payload : comment
      );
    },

    deleteCommentFromDoctor(state, action) {
      const comment = state.doctor.comments.find(
        (c) => c._id === action.payload
      );

      const commentIndex = state.doctor.comments.indexOf(comment);
      state.doctor.comments.splice(commentIndex, 1)
    },
  },
});
const doctorsReducer = doctorsSlice.reducer;
const doctorsActions = doctorsSlice.actions;

export { doctorsReducer, doctorsActions };
